import {Component, ViewEncapsulation} from '@angular/core';
import { OfferCardType } from "../../offer-card-data.model";
import { AbstractOfferCard } from '../abstract-offer-card.component';

@Component({
  selector: 'just-dates-offer-card',
  template: `
    <offer-card [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId" [positionIndex]="positionIndex"
                [data]="data" [currency]="currency" [locale]="locale"
                [loyaltyMode]=" loyaltyMode"
                [flow]="flow" [product]="product" [moduleReferer]="moduleReferer">

      <ng-container offer-content *ngIf="data.dates.from?.text">
        <ng-container *ngTemplateOutlet="data.dates.to?.text ? withReturn : withoutReturn"></ng-container>
      </ng-container>

      <ng-template #withReturn>
        <div class="with-return-wrapper">
          <span *ngIf="data.dates.from?.date && data.dates.to?.date" class="-eva-3-mb-sm eva-3-h4">
          {{getDatesDiff(data.dates.from!.date, data.dates.to!.date)}} {{'offers.dates.days' | translate}}
        </span>
          <span class="offer-date-wrapper">
            {{'offers.dates.departure' | translate}}
            <em class="offer-date -eva-3-tc-gray-1 -eva-3-bold">{{data.dates.from!.text}}</em>
            | {{'offers.dates.arrival' | translate}}
            <em class="offer-date -eva-3-tc-gray-1 -eva-3-bold">{{data.dates.to!.text}}</em>
        </span>
        </div>
      </ng-template>

      <ng-template #withoutReturn>
          <span class="offer-date-wrapper">
            {{'offers.dates.departure' | translate}}
            <em class="offer-date -eva-3-tc-gray-1 -eva-3-bold">{{data.dates.from!.text}}</em>
          </span>
      </ng-template>
    </offer-card>
  `,
  styleUrls: ['./just-dates-offer-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class JustDatesOfferCardComponent extends AbstractOfferCard {
  readonly offerCardType = OfferCardType.MINI;

  getDatesDiff = (firstDate: string, secondDate: string) : number => {
    const date1 = new Date(firstDate);
    const date2 = new Date(secondDate);
    if (date1 && date2) {
      // @ts-ignore
      return Math.ceil(Math.abs(date1 - date2) / (1000 * 60 * 60 * 24));
    } else {
      return 0;
    }
  }
}
